module.exports = __webpack_public_path__ + "static/screenshot4-2276d5175dd5498abd962648fa4e8c29.png";